import React, { useEffect, useState, useRef } from "react";

const CountdownTimer = ({ start }) => {
  const [phase, setPhase] = useState("idle");   
  const [preCount, setPreCount] = useState(3);   
  const [elapsed, setElapsed] = useState(0);    
  const preTimerRef = useRef(null);
  const mainTimerRef = useRef(null);

  useEffect(() => {
    if (start && phase === "idle") {
      setPhase("pre");
      setPreCount(3);
    }
  }, [start, phase]);

  useEffect(() => {
    if (phase !== "pre") return;
    preTimerRef.current = setInterval(() => {
      setPreCount((prev) => {
        if (prev <= 1) {
          clearInterval(preTimerRef.current);
          setPhase("main");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(preTimerRef.current);
  }, [phase]);

  useEffect(() => {
    if (phase !== "main") return;
    if (start) {
      mainTimerRef.current = setInterval(() => {
        setElapsed((prev) => {
          const next = Math.min(prev + 0.1, 59);
          if (next >= 59) clearInterval(mainTimerRef.current);
          return next;
        });
      }, 100);
    }
    return () => clearInterval(mainTimerRef.current);
  }, [phase, start]);

  const progress = (elapsed / 59) * 100;

  const radius = 22;
  const stroke = 4;
  const normalizedRadius = radius - stroke * 0.5;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset =
    circumference - (progress / 100) * circumference;

  return (
    <div className="flex items-center justify-center">
      {phase === "pre" ? (
        <div className="text-white font-bold text-3xl">
          {preCount}
        </div>
      ) : phase === "main" ? (
        <svg
          height={radius * 2}
          width={radius * 2}
          className="rotate-[-90deg]"
        >
          <circle
            stroke="#3B3B3B"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke="#C6E675"
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            style={{
              strokeDashoffset,
              transition: "stroke-dashoffset 0.1s linear",
            }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
      ) : null}
    </div>
  );
};

export default CountdownTimer;
